import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: process.env.REACT_APP_LOCALE_DEFAULT,
        debug: false,

        detection: {
            order: ['querystring', 'cookie'],
            lookupCookie: 'ui_locale',
            cookieOptions: {httpOnly: false, secure: false, domain: process.env.REACT_APP_LOCALE_COOKIE_DOMAIN},
            lookupQuerystring: 'lng',
            caches: ['cookie'],
        },

        react: {
            bindI18nStore: 'added',
        },
    });

export default i18n;